import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../hooks/axios/useAxios";
import {documentPatchByIdUrl} from "../../constants/api/endpoints";
import { toast } from "react-toastify";

interface SubmitDocumentParams {
  id: string;
  title?: string,
  description?: string
}

export const usePatchDocument = () => {
  const axios = useAxios();

  return useMutation({
    mutationFn: async ({ id, title, description }: SubmitDocumentParams) => {
      const response = await axios.patch(documentPatchByIdUrl(id), {
        title,
        description
      });
      return response.data;
    },
    retry: false,
  });
};